module.exports = __webpack_public_path__ + "img/246-wales.ef9d1ff2.svg";